import { SIDE_PANEL_CLEAN_UP } from 'actions/sidePanel';
import { IS_FORM_DIRTY, SHOW_CHICKEN_EXIT } from 'actions/userPropertiesPage';

export const defaultState = {
  isFormDirty: false,
  showChickenExit: false,
};

export default function userPropertiesPage(state = defaultState, action) {
  switch (action.type) {
    case IS_FORM_DIRTY: {
      return {
        ...state,
        isFormDirty: action.payload,
      };
    }
    case SHOW_CHICKEN_EXIT: {
      return {
        ...state,
        showChickenExit: action.payload,
      };
    }
    case SIDE_PANEL_CLEAN_UP: {
      return {
        ...state,
        isFormDirty: false,
        showChickenExit: false,
      };
    }
    default: {
      return state;
    }
  }
}
